import { render, staticRenderFns } from "./prioritaeten-view.vue?vue&type=template&id=9570be0e"
import script from "./prioritaeten-view.vue?vue&type=script&lang=js"
export * from "./prioritaeten-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports